/**
 * Validation utilities
 */

export const validateEmail = (email) => {
  if (!email || typeof email !== 'string') return false;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
};

export const isValidEmail = (email) => {
  if (!email) return false;
  return validateEmail(email);
};

/**
 * Form validation helper
 */
export const validateForm = (fields) => {
  const errors = {};

  Object.entries(fields).forEach(([key, value]) => {
    if (key.toLowerCase().includes('email')) {
      if (!isValidEmail(value)) {
        errors[key] = 'Adresse email invalide';
      }
    }
    if (!value || value.trim() === '') {
      errors[key] = 'Ce champ est requis';
    }
  });

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};
